<template>
    <v-container
            v-if="$store.state.menu.Dashboard"
            fill-height
            fluid
            grid-list-xl
    >
        <Loader :loading="loading"/>
        <v-layout wrap>

            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="silver"
                        icon="mdi-account"
                        title="Дилеры"
                        :value="count.dealer | numberWithSpaces"
                        small-value="аккаунтов"
                        sub-text="Количество зарегистрированных дилеров"
                />
            </v-flex>
            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="green"
                        icon="mdi-account"
                        title="Активные дилеры"
                        :value="count.dealer_active | numberWithSpaces"
                        small-value="аккаунтов"
                        sub-text="Количество активированных дилеров"
                />
            </v-flex>

            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card

                        color="blue"
                        icon="mdi-laptop"
                        title="Наименований товаров"
                        :value="count.products | numberWithSpaces"
                        small-value="шт."

                        :sub-text="'Количество серийников: ' +count.serials | numberWithSpaces"

                />
            </v-flex>

            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card

                        color="red"
                        icon="mdi-coin"
                        title="Оплачено бонусами"
                        :value="count.paid_bonus | numberWithSpaces"
                        small-value="сум"
                        sub-text="Сумма, на которую были куплены товары"
                />
            </v-flex>
            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card

                        color="red"
                        icon="mdi-bank"
                        title="Активные бонусы"
                        :value="count.bonus | numberWithSpaces"
                        small-value="сум"
                        sub-text="Общее число с учетом покупок и вывода средсв"
                />
            </v-flex>
            <v-flex
                    sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="brown"
                        icon="mdi-qrcode-scan"
                        title="Активации дилеров"
                        :value="count.activations | numberWithSpaces"
                        small-value="товаров"
                        sub-text="Приложение Customer Service"
                />
            </v-flex>


            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="blue"
                        icon="mdi-cart-outline"
                        title="Выполненные заказы дилеров"
                        :value="count.orders | numberWithSpaces"
                        small-value="шт."
                        sub-text="Заказы, которые были завершены"
                />
            </v-flex>


            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="silver"
                        icon="mdi-account-supervisor"
                        title="Участники акций"
                        :value="count.client | numberWithSpaces"
                        small-value="человек"
                        sub-text="Пользователи сайта client.customerservice.uz"
                />
            </v-flex>


            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="brown"
                        icon="mdi-wallet-giftcard"
                        title="Активировали по акциям"
                        :value="count.raffle_activations | numberWithSpaces"
                        small-value="товаров"
                        :sub-text="'В активных акциях: ' + count.raffle_active_activations + ' товаров' | numberWithSpaces"
                />
            </v-flex>


            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="orange"
                        icon="mdi-barcode"
                        title="Установлено наклеек на товары"
                        :value="count.serials_active | numberWithSpaces"
                        small-value="наклеек"
                        sub-text="Товаров готовых к активациям"
                />
            </v-flex>


            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="red"
                        icon="mdi-currency-usd-off"
                        title="Вывод средств"
                        :value="count.withdraw | numberWithSpaces"
                        small-value="сум"
                        sub-text="Сколько выведено средств"
                />
            </v-flex>

              <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="red"
                        icon="mdi-cash"
                        title="Общее число бонусов"
                        :value="count.total | numberWithSpaces"
                        small-value="сум"
                        sub-text="Без учета покупок и вывода"
                />
            </v-flex>

            <v-flex sm12
                    xs12
                    md6
                    lg4
            >
                <material-stats-card
                        color="green"
                        icon="mdi-currency-usd"
                        title="Начисление"
                        :value="count.discount | numberWithSpaces"
                        small-value="сум"
                        sub-text="Сколько начислено дилерам"
                />
            </v-flex>

          


            <!--Список дилеров-->

            <v-flex xs12
            ></v-flex>


            <v-flex md4
                    lg4
            >
                <material-card color="gray"
                               title="Список новых дилеров"
                               text="последних 10  зарегистрированных"
                >

                    <v-btn color="warning"
                           to="/dealers"
                           class="right"
                           text>
                        Показать все
                    </v-btn>

                    <v-data-table :headers="headers"
                                  :items="dealersList"
                                  hide-actions
                    >
                        <template slot="headerCell"
                                  slot-scope="{ header }"
                        >
                          <span class="font-weight-light text-warning text--darken-3"
                                v-text="header.text"
                          />
                        </template>

                        <template slot="items"
                                  slot-scope="{ index, item }">
                            <td @click="SET_USER(item.id)" class="text-xs-left min-width200">
   
                                <span>{{ item.title }}</span>
                                <br/>
                                <b>                       {{ item.phone_number }}</b>
                            </td>

                            <td class="text-xs-left min-width100">
                                <span v-if="item.is_active" class="text-success">Активен</span>
                                <span v-else class="error--text">Не активен</span>
                            </td>

                            <td @click="SET_USER(item.id)" class="text-xs-right min-width100">

                                USER ID: <b>{{item.id}}</b> <br>
                                <small>{{ item.created_at | dateTime}}</small>
                            </td>
                        </template>
                    </v-data-table>


                </material-card>
            </v-flex>


            <!--Активации-->
            <v-flex md4
                    lg4
            >
                <material-card color="gray"
                               title="Список активаций"
                               text="последних 10  активированных товаров"
                >


                    <v-btn color="warning"
                           to="/activations"
                           class="right"
                           text>
                        Показать все
                    </v-btn>

                    <v-data-table :headers="headersActivations"
                                  :items="activationsList"
                                  hide-actions
                    >
                        <template slot="headerCell"
                                  slot-scope="{ header }"
                        >
                          <span class="font-weight-light text-warning text--darken-3"
                                v-text="header.text"
                          />
                        </template>

                        <template slot="items"
                                  slot-scope="{ index, item }">
                            <td :class="`${(item.reward===0) ? 'error--text' : ''} text-xs-left min-width200`">
                                <span v-if="item.product">
                                <small> {{ item.product.title }}</small>
                                    <br/>
                                    <span v-if="item.reward>=0">Артикул:</span> <b> {{item.product.vendor_code}}</b>
                                </span>
                            </td>
                            <td :class="`${(item.reward===0) ? 'error--text' : ''} text-xs-left min-width100`">
                                <span v-if="item.dealer">
                                    {{item.dealer.title}}
                                    <br/>
                                    <b>{{item.dealer.phone_number}}</b>
                                </span></td>
                            <td class="text-xs-right ">
                                <span v-if="item.reward>=0">Получил:</span>
                                <span v-else>Вывел:</span>

                                <b> {{item.reward | numberWithSpaces}} сум</b>
                                <br>
                                <span v-if="item.reward>=0">с/н:</span> <b
                                    class="text-success"> {{item.serial_number}}</b> <br>
                                <small>{{ item.created_at | dateTime}}</small>
                            </td>
                        </template>
                    </v-data-table>


                </material-card>
            </v-flex>

            <!--Список заказов-->
            <v-flex md4
                    lg4
                    v-if="ordersList.length"
            >
                <material-card color="gray"
                               title="Список последних заказов"
                               text="последние 10 заказов"
                >

                    <v-btn color="warning"
                           to="/orders"
                           class="right"
                           text>
                        Показать все
                    </v-btn>


                    <v-data-table :headers="headersOrders"
                                  :items="ordersList"
                                  hide-actions
                    >
                        <template slot="headerCell"
                                  slot-scope="{ header }"
                        >
                          <span class="font-weight-light text-warning text--darken-3"
                                v-text="header.text"
                          />
                        </template>

                        <template slot="items"
                                  slot-scope="{ index, item }">
                            <td class="text-xs-left min-width100">CS-{{ item.id }}
                                <br/>
                                <b v-if="item.status===1">Новый</b>
                                <b v-else-if="item.status===2" class="text-success">Выполнен</b>
                                <b v-else-if="item.status===3" class="error--text">Отменен</b>
                            </td>

                            <td class="text-xs-left">
                                <span v-if="item.dealer">
                                    {{item.dealer.title}}
                                    <br/>
                                    <b>{{item.dealer.phone_number}}</b>
                                </span>
                            </td>
                            <td class="text-xs-right">
                                <small>{{ item.created_at | dateTime}}</small>
                            </td>
                        </template>
                    </v-data-table>


                </material-card>
            </v-flex>


            <!--<v-flex v-if="0"-->
            <!--md12-->
            <!--sm12-->
            <!--lg4-->
            <!--&gt;-->
            <!--<material-chart-card :data="emailsSubscriptionChart.data"-->
            <!--:options="emailsSubscriptionChart.options"-->
            <!--:responsive-options="emailsSubscriptionChart.responsiveOptions"-->
            <!--color="green"-->
            <!--type="Bar"-->
            <!--&gt;-->
            <!--<h4 class="title font-weight-light">Заказы диллеров</h4>-->
            <!--<template slot="actions">-->
            <!--<v-icon-->
            <!--class="mr-2"-->
            <!--small-->
            <!--&gt;-->
            <!--mdi-clock-outline-->
            <!--</v-icon>-->
            <!--<span class="caption grey&#45;&#45;text font-weight-light">Годовой график по месяцам</span>-->
            <!--</template>-->
            <!--</material-chart-card>-->
            <!--</v-flex>-->

            <!--<v-flex v-if="0"-->
            <!--md12-->
            <!--sm12-->
            <!--lg4-->
            <!--&gt;-->
            <!--<material-chart-card-->
            <!--:data="emailsSubscriptionChart.data"-->
            <!--:options="emailsSubscriptionChart.options"-->
            <!--:responsive-options="emailsSubscriptionChart.responsiveOptions"-->
            <!--color="red"-->
            <!--type="Bar"-->
            <!--&gt;-->
            <!--<h4 class="title font-weight-light">Диллеры AVTECH</h4>-->


            <!--<template slot="actions">-->
            <!--<v-icon-->
            <!--class="mr-2"-->
            <!--small-->
            <!--&gt;-->
            <!--mdi-clock-outline-->
            <!--</v-icon>-->
            <!--<span class="caption grey&#45;&#45;text font-weight-light">Годовой график по месяцам</span>-->
            <!--</template>-->
            <!--</material-chart-card>-->
            <!--</v-flex>-->

            <!--<v-flex v-if="0"-->
            <!--md12-->
            <!--sm12-->
            <!--lg4-->
            <!--&gt;-->
            <!--<material-chart-card :data="emailsSubscriptionChart.data"-->
            <!--:options="emailsSubscriptionChart.options"-->
            <!--:responsive-options="emailsSubscriptionChart.responsiveOptions"-->
            <!--color="orange"-->
            <!--type="Bar"-->
            <!--&gt;-->
            <!--<h4 class="title font-weight-light">Активация товаров</h4>-->


            <!--<template slot="actions">-->
            <!--<v-icon-->
            <!--class="mr-2"-->
            <!--small-->
            <!--&gt;-->
            <!--mdi-clock-outline-->
            <!--</v-icon>-->
            <!--<span class="caption grey&#45;&#45;text font-weight-light">Годовой график по месяцам<</span>-->
            <!--</template>-->
            <!--</material-chart-card>-->
            <!--</v-flex>-->


        </v-layout>

        <Dealer/>
    </v-container>
</template>

<script>
    import {mapState, mapMutations} from 'vuex';
    import Loader from "../components/helper/Loader";
    import Dealer from "../components/core/Dealer";

    export default {
        components: {Dealer, Loader},
        data() {
            return {

                loading: true,
                count: {
                    dealer: 0,
                    products: 0,
                    paid_bonus: 0,
                    bonus: 0,
                    orders: 0,
                    activations: 0,
                    raffle_activations: 0,
                    raffle_active_activations: 0,
                    serials_active: 0,
                    client: 0,
                    total: 0,
                    withdraw: 0,
                    discount: 0,
                    serials: 0
                },

                emailsSubscriptionChart: {
                    data: {
                        labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
                        series: [
                            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]
                        ]
                    },
                    options: {
                        axisX: {
                            showGrid: false
                        },
                        low: 0,
                        high: 1000,
                        chartPadding: {
                            top: 0,
                            right: 5,
                            bottom: 0,
                            left: 0
                        }
                    },
                    responsiveOptions: [
                        ['screen and (max-width: 640px)', {
                            seriesBarDistance: 5,
                            axisX: {
                                labelInterpolationFnc: function (value) {
                                    return value[0]
                                }
                            }
                        }]
                    ]
                },
                headers: [
                    {
                        sortable: false,
                        text: 'Дилер',
                        value: 'first_name',
                        align: 'left'
                    },

                    {
                        sortable: false,
                        text: 'Статус',
                        value: 'first_name',
                        align: 'left'
                    },

                    {
                        sortable: false,
                        text: 'Дата',
                        value: 'address',
                        align: 'right'
                    },
                ],

                headersActivations: [
                    {
                        sortable: false,
                        text: 'Товар',
                        value: 'first_name',
                        align: 'left'
                    },
                    {
                        sortable: false,
                        text: 'Дилер',
                        value: 'address',
                        align: 'left'
                    },
                    {
                        sortable: false,
                        text: 'Награда',
                        value: 'address',
                        align: 'right'
                    },
                ],

                headersOrders: [
                    {
                        sortable: false,
                        text: 'Заказ',
                        value: 'first_name',
                        align: 'left'
                    },
                    {
                        sortable: false,
                        text: 'Дилер',
                        value: 'first_name',
                        align: 'left'
                    },

                    {
                        sortable: false,
                        text: 'Дата',
                        value: 'address',
                        align: 'right'
                    },
                ],

                dealersList: [],

                activationsList: [],

                ordersList: [],

                tabs: 0,

                list: {
                    0: false,
                    1: false,
                    2: false
                }

            }
        },
        methods: {


            ...mapMutations(['SET_USER']),
            getCount(loading) {
                axios.get('admin/analytics/counts').then(response => {
                    this.count = response.data.count;
                    // let bonus = setInterval(() => {
                    //     if (response.data.bonus >= this.count.bonus) {
                    //         clearInterval(bonus);
                    //     }
                    //     this.count.bonus++;
                    // }, 0);
                    this.getDealers();
                    this.getActivatins();
                    this.getOrders();
                }).catch(error => {

                }).finally(() => {
                    this.loading = false;
                });
            },
            getDealers() {
                axios.get('admin/dealers', {
                    params: {
                        per_page: 10,
                        is_new: 1,
                        page: 1
                    }
                }).then(response => {
                    this.dealersList = response.data.data;
                    this.loading = false;
                }).catch(error => {

                });
            },
            getOrders() {
                axios.get('admin/orders', {
                    params: {
                        per_page: 10,
                        is_new: 1,
                        page: 1
                    }
                }).then(response => {
                    this.ordersList = response.data.data;
                    this.loading = false;
                }).catch(error => {

                });
            },
            getActivatins() {
                axios.get('admin/activations', {
                    params: {
                        per_page: 10,
                        is_new: 1,
                        page: 1
                    }
                }).then(response => {
                    this.activationsList = response.data.data;
                    this.loading = false;
                }).catch(error => {

                });
            },
            animateNumber(be, now) {
                let set = 0;
                while (be <= now) {
                    setTimeout(() => {
                        set++;
                    }, 30);
                }

                return set;
            }
        },
        mounted() {
            this.loading = true;
            setTimeout(() => {
                this.getCount();
            }, 400);


        },

        computed: {
            ...mapState(['badge'])
        },

        watch: {
            badge() {
                this.getCount();
            }
        }
    }
</script>

<style>
    .category {

        font-size: 13px !important;
        color: #666 !important;
        font-weight: 700 !important;
    }

    .v-card--material-stats.v-card .title small {
        font-weight: 300;
        color: #999 !important;
    }
</style>


